import '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';

const Waypoint = ({ item, coordinates, directionToNext, onEnter = (item) => {}, onLeave = (item) => {}, onClick, isCompleted, isActive, isNext }) => {
  const [isHovered, setIsHovered] = useState(false);
  const waypointSize = 40; // Radius des Wegpunktes
  const waypointBorderWidth = 2; // Breite des Wegpunktrandes
  const waypointBorderColor = "black"; // Farbe des Wegpunktrandes
  const activeWaypointColor = isActive ? "red" : "beige";
  const waypointColor = isCompleted ? "green" : activeWaypointColor;
  const activeHoverWaypointColor = isActive ? "darkred" : "beige";
  const hoverColor = isCompleted ? "#006400" : activeHoverWaypointColor;
  const xOffset = 50;
  const yOffset = 50;
  const type = item.shape;

  const handleMouseEnter = () => {
    setIsHovered(true);
    onEnter && onEnter(item);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    onLeave && onLeave(item);
  };

  const handleMouseClick = (item) => {
    if (!isCompleted && !isActive) return;
    onClick && onClick(item);
  }

  const getTextPosition = () => {
    switch (directionToNext) {
      case "upper-corner-right":
        return { x: coordinates.x, y: coordinates.y - yOffset };
      case "lower-corner-right":
        return { x: coordinates.x + xOffset, y: coordinates.y - yOffset };
      case "upper-corner-left":
        return { x: coordinates.x, y: coordinates.y - yOffset };
      case "lower-corner-left":
        return { x: coordinates.x - xOffset, y: coordinates.y - yOffset };
      default: // "standard"
        return { x: coordinates.x, y: coordinates.y - yOffset }; // Standardposition
    }
  };
  
  const textPosition = getTextPosition();

  const renderWaypointShape = () => {
    if (type === "rect") {
      return (<>
          <rect
          x={coordinates.x - waypointSize }
          y={coordinates.y - waypointSize }
          width={waypointSize * 2}
          height={waypointSize * 2}
          fill={waypointBorderColor}          
          filter="url(#shadow)"
        />
        <rect
          x={coordinates.x - waypointSize + 2}
          y={coordinates.y - waypointSize + 2}
          width={waypointSize * 2 - 4}
          height={waypointSize * 2 - 4}
          fill="beige"          
        />
        <rect
          x={coordinates.x - waypointSize + 5}
          y={coordinates.y - waypointSize + 5}
          width={waypointSize * 2 - 10}
          height={waypointSize * 2 - 10}
          fill={isHovered ? hoverColor : waypointColor}          
        />
      </>);
    } else {
      return (
        <>
          <circle 
            cx={coordinates.x} 
            cy={coordinates.y} 
            r={waypointSize + waypointBorderWidth} 
            fill={waypointBorderColor}
            filter="url(#shadow)"
          />
          <circle 
            cx={coordinates.x} 
            cy={coordinates.y} 
            r={waypointSize} 
            fill="beige"
          />
          <circle 
            cx={coordinates.x} 
            cy={coordinates.y} 
            r={waypointSize - 5} 
            fill={isHovered ? hoverColor : waypointColor}
          />
        </>
      );
    }
  };

  const showImage = isActive || isCompleted;
  const hasImage = (item.image !== undefined && item.image !== null && item.image !== "") && showImage;
  const image = 
    <g transform={`translate(${coordinates.x - waypointSize/2 - 5}, ${coordinates.y - waypointSize/2 +5})`}>
      <image href={item.image} width="50"  y="-10" />
    </g>
        
  const showIcon = isNext || isActive || isCompleted;
  const hasIcon = (item.icon !== undefined && item.icon !== null && item.icon !== "") && showIcon;

  const iconScale = 0.2; 
  const iconOffsetX = -waypointSize/2; 
  const iconOffsetY = -waypointSize/2 ;

  const iconPosition = {
    x: (coordinates.x) + iconOffsetX,
    y: (coordinates.y) + iconOffsetY
  };

  const iconSvg = isNext ? "fa-question" : item.icon;
  const icon = <g>
    <svg x={iconPosition.x} y={iconPosition.y} 
      transform={`scale(${iconScale})`} 
      width={waypointSize} 
      height={waypointSize}>
        <FontAwesomeIcon icon={iconSvg} />
    </svg>
  </g>
        
  return (
    <g
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={() => handleMouseClick(item)}
      style={{ cursor: isActive ? 'pointer' : 'default' }}
    >      
      {renderWaypointShape()}      
      { hasIcon && !hasImage && icon }
      { hasImage && !hasIcon &&  image }
      { (isCompleted || isActive) && (
        <text x={textPosition.x} y={textPosition.y}
          fill="black" textAnchor="middle" dy=".3em" fontWeight="bold" >
          {item.title}
        </text>
      )}
    </g>
  );
};

export default Waypoint;